import { InjectionToken } from '@angular/core';
import { DATE_CONSTANTS } from '../../constants/date.constants';

/**
 * @description   Get a date object that starts at the beginning of the month
 * @param dateObj Date object
 */
export const getStartOfMonth = (dateObj: Date): Date => {
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');

    return new Date(`${year}-${month}-01${DATE_CONSTANTS.timeZone}`);
};

export type GetStartOfMonthProvider = (dateObj: Date) => Date;
export const GET_START_OF_MONTH =
    new InjectionToken('GET_START_OF_MONTH', {
        factory: () => getStartOfMonth
    });
